import React, { useEffect, useState } from "react";
import "../Style/Component/Personaldata.css";
import profile from "../Assets/Personaldata/profile.png";
import accept from "../Assets/Personaldata/accept.svg";
import rating from "../Assets/Personaldata/rating.svg";
import cancel from "../Assets/Personaldata/cancel.svg";
import skip from "../Assets/Personaldata/skip.svg";
import bhim from "../Assets/Personaldata/bhim.svg";
import circle from "../Assets/Personaldata/circle.svg";
import circle2 from "../Assets/Personaldata/circle2.svg";
import back from "../Assets/Personaldata/back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getWithTokenAPI, postWithTokenAPI } from "../Util/Api.js";
import { toast } from "react-toastify";
const Personaldata = ({ data, stats, refreshDriverData }) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const { type, id } = useParams();
  const formatINR = (amount) => {
    if (!amount || amount === 0) return "0";
    return `₹ ${amount.toLocaleString("en-IN")}`;
  };

  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState("");


  const HandleCreateMoney = async () => {
    try {

      const payload = {
        [type === "driver" ? "driverId" : "userId"]: id,
        amount: amount,
        reason: "admin_credit"
      };

      const res = await postWithTokenAPI(
        token,
        "/admin/send-money",
        payload
      );

      if (res?.statusCode === 200) {
        toast.success("Money sent successfully");
        setOpen(false);
        setAmount("");
        refreshDriverData()
      } else {
        toast.error(res?.message || "Something went wrong");
      }

    } catch (error) {
      console.log(error);
      toast.error("Failed to send money");
    }
  };

  return (
    <div className="personaldata">
      <span className="personaldataheading">
        <img
          src={back}
          style={{ marginRight: "10px", cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        {type === "driver" ? "Driver data" : "Customer Profile"}
      </span>
      <div className="personaldatabody">
        <div className="typebasedimage">
          {/* <img
              src={data?.profileimage || profile}
              className={`profile_img ${type !== "driver" ? "round" : ""}`}
            /> */}
          <div className="avatar-wrapper">
            {data?.profileimage ? (
              <img
                src={data.profileimage}
                alt="profile"
                className="data-avatar"
              />
            ) : (
              <div className="data-avatar-fallback">
                {data?.name?.[0].toUpperCase()}
                {data?.name?.slice(-1).toUpperCase()}
              </div>
            )}
          </div>
        </div>
        <div className="typebaseddata">
          {type === "driver" ? (
            <div className="personaldatadetails">
              <div className="personaldetailsrow">
                <span className="detailslabel">Name:</span>
                <span className="detailsvalue">{data?.name}</span>
              </div>
              <div className="personaldetailsrow">
                <span className="detailslabel">Vehicle Type:</span>
                <span className="detailsvalue">
                  {data?.driverDetails?.vehicle?.vehicleType?.replace(/_/g, " ")}
                </span>
              </div>
              <div className="personaldetailsrow">
                <span className="detailslabel">Vehicle no:</span>
                <span className="detailsvalue">
                  {data?.driverDetails?.vehicle?.registrationNo}
                </span>
              </div>
              <div className="personaldetailsrow">
                <span className="detailslabel">Status:</span>
                <span className="detailsvalue forstatus">
                  <span
                    className={`detailsvaluestatus ${data?.status === "Active" ? "active" : "inactive"}`}
                  >
                    <span className="round"></span>
                  </span>
                  <span className="personaldatadetailsstatus">
                    {data?.status}
                  </span>
                </span>
              </div>
            </div>
          ) : (
            <div className="userflow">
              <span className="personaldetailsname">{data?.name}</span>
              <span className="personaldetailsnumber">
                +91{data?.phoneNumber}
              </span>
              <span className="personaldetailsgender">
                <b>Gender : </b>
                {data?.gender}
              </span>
            </div>
          )}
        </div>
        <div className="personaldatabody">
          {type === "driver" ? (
            <div className="personaldatabodycard">
              <div className="toppcard">
                <div className="ccaarrdd accept">
                  <img src={accept}></img>
                  <div className="ccaarrddtext">
                    <span>Ride accept</span>
                    <span style={{ color: "black" }}>{stats?.rideAccept}</span>
                  </div>
                </div>
                <div className="pdwallet">
                  <img src={circle} className="ellipse"></img>
                  <div className="rupees">
                    <span className="rupeehead">Wallet</span>
                    <span className="rupeebody">
                      {formatINR(stats?.walletAmount)}
                    </span>
                  </div>
                  <div className="send" onClick={() => setOpen(true)}>
                    <img src={bhim}></img>
                    <span className="sendmoney">Send Money</span>
                  </div>
                  <img src={circle2} className="ellipse2"></img>
                </div>
              </div>
              <div className="bottomcard">
                <div className="ccaarrdd rating">
                  <img src={rating}></img>
                  <div className="ccaarrddtext">
                    <span>Rating</span>
                    <span style={{ color: "black" }}>{stats?.rating} Star</span>
                  </div>
                </div>
                <div className="ccaarrdd cancell">
                  <img src={cancel}></img>
                  <div className="ccaarrddtext">
                    <span>Ride cancel</span>
                    <span style={{ color: "black" }}>{stats?.rideCancel}</span>
                  </div>
                </div>
                <div className="ccaarrdd skip">
                  <img src={skip}></img>
                  <div className="ccaarrddtext">
                    <span>Ride skip</span>
                    <span style={{ color: "black" }}>{stats?.rideSkip}</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="userwallet">
              <div className="pdwallet">
                <img src={circle} className="ellipse"></img>
                <div className="rupees">
                  <span className="rupeehead">Wallet</span>
                  <span className="rupeebody">
                    {formatINR(stats?.walletAmount)}
                  </span>
                </div>
                <div className="send" onClick={() => setOpen(true)}>
                  <img src={bhim}></img>
                  <span className="sendmoney" >Send Money</span>
                </div>
                <img src={circle2} className="ellipse2"></img>
              </div>
            </div>
          )}
        </div>
      </div>


      {open && (
        <div className="money-modal-backdrop">
          <div className="money-modal-card">

            <div className="money-modal-title">
              Send Money
            </div>

            <input
              type="number"
              placeholder="Enter Amount"
              className="money-modal-input"
              value={amount}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numbers
                if (/^\d*$/.test(value)) {
                  setAmount(value);
                }
              }}
            />

            <div className="money-modal-actions">

              <button
                className="money-modal-btn money-modal-btn-cancel"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>

              <button
                className="money-modal-btn money-modal-btn-send"
                onClick={HandleCreateMoney}
              >
                Send
              </button>

            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Personaldata;
